import { AxiosError } from 'axios';
import Api from '../Api';
import { Locale } from '../../types/gatsby';

export const buildContenfulBaseURL = (baseURL: string, spaceId: string, environment: string) =>
  `${baseURL}/spaces/${spaceId}/environments/${environment}`;

class ContentfulService extends Api {
  static queries = {
    productReviewPage: `
      query getReviewPage($productPageId: String!, $locale: String!) {
        productContent(id: $productPageId, locale: $locale) {
          slug
          productCategory {
            slug
          }
        }
      }`,
  };

  query = async <ResponseData>({
    query,
    variables,
  }: {
    query: string;
    variables: object;
  }, retry: number = 0): Promise<ResponseData> => {
    try {
      const response = await this.httpClient.post<ResponseData>('/', {
        query,
        variables,
      });

      return response.data;
    } catch (error) {
      if (
        error instanceof AxiosError
        && error.response?.status === 429 // Too many requests status code
        && retry <= 3
      ) {
        await new Promise((resolve) => {
          setTimeout(resolve, (retry + 1) * 1000);
        });
        return this.query<ResponseData>({
          query,
          variables,
        }, retry + 1);
      }

      throw error;
    }
  };

  /**
   * @deprecated Use ContentfulService.query instead.
   */
  getReviewPage = async (productPageId: string, locale: Locale) => {
    try {
      const { data } = await this.httpClient.post('/', {
        query: ContentfulService.queries.productReviewPage,
        variables: { productPageId, locale },
      });

      return data;
    } catch (error) {
      throw new Error(`Something went wrong while getting review page from Contentful: ${error}`);
    }
  };
}

export { ContentfulService };
